import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IconAssets, OnboardingAssets } from 'src/config';

import { OnboardingItem } from './onboardingItem';

export const Onboarding = () => {
	const { t } = useTranslation();

	return (
		<Flex
			flexDir="column"
			gridGap={{ base: '20px', md: '40px' }}
		>
			<OnboardingItem
				step={1}
				content={<>{t('onboarding.texts.metamask')}</>}
				image={OnboardingAssets.metamask}
				header={t('onboarding.headers.metamask')}
				links={[
					{
						text: t('onboarding.links.installMetamask'),
						href: 'https://metamask.io/',
					},
				]}
			/>
			<OnboardingItem
				step={2}
				content={<>{t('onboarding.texts.matic')}</>}
				image={OnboardingAssets.matic}
				header={t('onboarding.headers.matic')}
				links={[
					{
						text: t('onboarding.links.ramp'),
						href: 'https://ramp.network/',
					},
				]}
			/>
			<OnboardingItem
				step={3}
				content={<>{t('onboarding.texts.graphics')}</>}
				image={OnboardingAssets.images}
				header={t('onboarding.headers.graphics')}
				links={[
					{
						text: t('onboarding.links.graphicSpecs'),
						href: 'https://cdn.hashup.it/docs/en/Graphic-specification-ENG.pdf',
					},
				]}
			/>
			<OnboardingItem
				step={4}
				content={<>{t('onboarding.texts.files')}</>}
				image={OnboardingAssets.gamepad}
				header={t('onboarding.headers.files')}
				//links={[]}
			/>
		</Flex>
	);
};
